const dateFormat = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}

const timeFormat = {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
}

const dateTimeFormat = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
}

const dateTimeMinFormat = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
}

const defaultFormats = {
  dateFormat,
  timeFormat,
  dateTimeFormat,
  dateTimeMinFormat,
}

export const getDateTimeFormats = (languages = []) => {
  return languages.reduce((acc, lang) => {
    acc[lang] = defaultFormats
    return acc
  }, {})
}
